import type { FaireProductEntity } from "../../entity_types/product";

export const p_xcfjs5hzu7: FaireProductEntity = {
  token: "p_xcfjs5hzu7",
  type: "product",
  name: "Silky Satin Sleep Eye Masks with Ribbon - GRACIA",
  brandName: "LoveLina",
  imageUrl:
    "https://cdn.faire.com/fastly/99c7ca9243a126a7b744c4b3046bb7aab1a7c1f0e492d33899eadb536690db2a.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9e2a347c59c8175060331567bd7fe3f69989bb1b75b0c21d1e9abd5bdfb1e983.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
